import * as types from '@/store/mutation-types';
import _ from 'lodash';

const mutations = {
  [types.ADD_CONTENT_BLOCK](state, p) {
    p.rootState.splice(parseInt(p.index + 1, 10), 0, p.newSection);
  },
  [types.REMOVE_CONTENT_BLOCK](state, p) {
    if (p.items.length > 1) {
      p.items.splice(p.index, 1);
    }
  },
  [types.SET_SECTION_ID](state, p) {
    const sec = p.sec;
    sec.hrefId = p.hrefId;
  },
  [types.REVERT_SECTION](state, p) {
    _.extend(p.section, p.initialState);
  },
  [types.SET_SECTION_ERROR](state, p) {
    const sec = p.sec;
    sec.sectionErrors[p.type] = p.error;
  },
  [types.SET_SECTION_HINT](state, p) {
    const sec = p.sec;
    sec.hint = p.hint;
  },
  [types.UPDATE_SECTION_VAL](state, p) {
    // we use the $set technique for when we need
    // to add new data on the fly, so they can be reactive
    // https://vuejs.org/v2/guide/reactivity.html <- see caveats
    p.vm.$set(p.sec, p.key, p.val);
  },
};

const actions = {
  async addContentBlock({ commit, rootState }, payload) {
    payload.rootState = rootState.TopControlBar.currentPage.blocks;
    commit(types.ADD_CONTENT_BLOCK, payload);
  },
  removeContentBlock: ({ commit }, payload) => {
    commit(types.REMOVE_CONTENT_BLOCK, payload);
  },
  setSectionError: ({ commit }, payload) => {
    commit(types.SET_SECTION_ERROR, payload);
  },
  revertSection: ({ commit }, payload) => {
    commit(types.REVERT_SECTION, payload);
  },
  setSectionHint: ({ commit }, payload) => {
    commit(types.SET_SECTION_HINT, payload);
  },
  setSectionId: ({ commit }, payload) => {
    commit(types.SET_SECTION_ID, payload);
  },
  updateSectionVal: ({ commit }, payload) =>
    new Promise((resolve) => {
      commit(types.UPDATE_SECTION_VAL, payload);
      resolve(payload);
    }),
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/vuex.js